import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-downloadpage',
  templateUrl: './downloadpage.component.html',
  styleUrls: ['./downloadpage.component.css']
})
export class DownloadpageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
